import styled from "styled-components/macro";
import { CheckBoxNoLabel } from "../../../../components/CheckBoxes/CheckBoxes";

export const HeaderCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
`;

export const CheckboxNoMargin = styled(CheckBoxNoLabel)`
  margin-right: 0;
`;

export const SpinnerContainer = styled.div`
  width: 24px;
  height: 24px;
`;
